import type { Variables, Cache, UpdatesConfig } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';
import updateImplementationsCache from './updateImplementationsCache';

import type {
  TuitionAllianzUpdateMutation, TuitionImplementationCreateMutation, TuitionImplementationUpdateMutation, RefundPolicyCreateOrUpdateMutation,
} from '@/graphql/generated/graphql';

const tuitionImplementation = {
  tuitionImplementationCreate: (data: TuitionImplementationCreateMutation, __: Variables, cache: Cache) => {
    invalidateQuery('tuitionImplementations', cache);
    updateImplementationsCache(cache, data.tuitionImplementationCreate.ref_code_id);
  },
  tuitionImplementationUpdate: (data: TuitionImplementationUpdateMutation, __: Variables, cache: Cache) => {
    updateImplementationsCache(cache, data.tuitionImplementationUpdate.ref_code_id);
  },
  refundPolicyCreateOrUpdate: (data: RefundPolicyCreateOrUpdateMutation, __: Variables, cache: Cache) => {
    if (data.refundPolicyCreateOrUpdate.tuition_implementation_id) {
      invalidateQuery(
        'refundPolicyByImplementationId',
        cache,
      );
    }
  },
  tuitionAllianzUpdate: (data: TuitionAllianzUpdateMutation, __: Variables, cache: Cache) => {
    updateImplementationsCache(cache, data.tuitionAllianzUpdate.ref_code_id);
  },
};

export default tuitionImplementation as UpdatesConfig['Mutation'];
